// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"VZ-z","subtitle":"WZ-z","wrapper":"XZ-z","leftArrow":"YZ-z","rightArrow":"ZZ-z"};